/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import SettingsAPI from '../../../api/SettingsAPI'
import moment from 'moment'
import {toast} from 'react-toastify'
import { useAuth } from '../../modules/auth'
import authAPI from '../../../api/authAPI'
import { Link } from 'react-router-dom'

function SettingUsers() {
  const [currentUser, setCurrentUser] = useState({user_id: null});
  const [showModal, setShowModal] = useState(false)
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
    role: '',
    permissions: [] as any,
  })
  const [userList, setUserList] = useState([])
  const [permissionList, setPermissionList] = useState<any>([])
  const [pendingUsers, setPendingUsers] = useState([])
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState<any>({})

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {name, value} = e.target
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }))
  }

  const handlePermissionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target
    setFormData((prevFormData) => {
      if (checked) {
        return {
          ...prevFormData,
          permissions: [...prevFormData.permissions, Number(value)],
        }
      } else {
        return {
          ...prevFormData,
          permissions: prevFormData.permissions.filter(
            (permission: any) => permission !== Number(value)
          ),
        }
      }
    })
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // Make the API call using the form data
    // Reset the form data
    let data = {
      name: formData?.fullName,
      phone: formData?.phoneNumber,
      email: formData?.email,
      role_id: formData?.role,
      permissions: formData.permissions,
    }

    // API calling
    SettingsAPI.addCompanyUser(data).then(
      (res: any) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message, {theme: 'dark'})
          setFormData({
            fullName: '',
            email: '',
            phoneNumber: '',
            role: '',
            permissions: [],
          })
          setShowModal(false)
          getPendingUser()
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  // get current user
  const getCurrentUser = () => {
    authAPI.getMyProfile().then((res: any) => {
      if (res?.data?.success) {
        setCurrentUser(res?.data.data)
      } else {
        setCurrentUser({user_id: null})
      }
    })
  }

  // get user list
  const getUserList = () => {
    SettingsAPI.getUserList().then(
      (res: any) => {
        if (res?.data?.success) {
          setUserList(res?.data?.data)
        } else {
          setUserList([])
        }
      },
      (err: any) => {
        setUserList([])
      }
    )
  }

  // get permission list
  const getPermissionList = () => {
    SettingsAPI.getPermissionList().then(
      (res: any) => {
        if (res?.data?.success) {
          setPermissionList(
            res?.data?.data?.map((e: any) => {
              return {
                ...e,
                value: e?.id,
                label: e?.title,
              }
            })
          )
        } else {
          setPermissionList([])
        }
      },
      (err: any) => {
        setPermissionList([])
      }
    )
  }

  // get pending list
  const getPendingUser = () => {
    SettingsAPI.getPendingUser().then(
      (res: any) => {
        if (res?.data?.success) {
          setPendingUsers(res?.data?.message)
        } else {
          setPendingUsers([])
        }
      },
      (err: any) => {
        setPendingUsers([])
      }
    )
  }
  // init
  useEffect(() => {
    getCurrentUser()
    getUserList()
    getPermissionList()
    getPendingUser()
  }, [])

  // resend invite
  const resendInvite = (id: number) => {
    let data = {
      id: id,
    }
    SettingsAPI.resendInvite(data).then(
      (res: any) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message, {theme: 'dark'})
          getPendingUser()
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  // revoke invite
  const revokeInvite = (id: number) => {
    let data = {
      id: id,
    }
    SettingsAPI.revokeInvite(data).then(
      (res: any) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message, {theme: 'dark'})
          getPendingUser()
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }
  // delete User
  const deleteUser = () => {
    SettingsAPI.deleteUser(selectedUser?.userDetails?.id).then(
      (res: any) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message, {theme: 'dark'})
          getPendingUser()
          getUserList()
          setDeleteModal(false)
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  // render
  return (
    <div>
      {/* Add User */}
      <div className='text-lg-end'>
        <button type='button' className='btn btn-primary' onClick={() => setShowModal(true)}>
          + Add User
        </button>
      </div>

      {/* Modal for ADD User */}
      {showModal && (
        <div className='modal' style={{display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
          <div className='modal-dialog modal-lg modal-dialog-centered'>
            <div className='modal-content container'>
              <div className='modal-header'>
                <h5 className='modal-title'>Add New User</h5>
                <button className='btn btn-close' onClick={() => setShowModal(false)}>
                  {/* <span aria-hidden='true'>&times;</span> */}
                </button>
              </div>
              <div className='modal-body users'>
                {/* Form */}
                <form onSubmit={handleSubmit}>
                  <div className='row mb-3'>
                    <div className='form-group col-lg-6'>
                      <label htmlFor='fullName'>Full Name</label>
                      <input
                        type='text'
                        id='fullName'
                        name='fullName'
                        className='form-control'
                        value={formData.fullName}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className='form-group col-lg-6'>
                      <label htmlFor='email'>Email</label>
                      <input
                        type='email'
                        id='email'
                        name='email'
                        className='form-control'
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className='row mb-3'>
                    <div className='form-group col-lg-6'>
                      <label htmlFor='phoneNumber'>Phone Number</label>
                      <input
                        type='text'
                        id='phoneNumber'
                        name='phoneNumber'
                        className='form-control'
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className='form-group col-lg-6'>
                      <label htmlFor='role'>Role</label>
                      <select
                        id='role'
                        name='role'
                        className='form-control form-select'
                        value={formData.role}
                        onChange={handleInputChange}
                      >
                        <option value=''>Select Role</option>
                        <option value={3}>Administrator</option>
                        <option value={4}>Reviewer</option>
                      </select>
                    </div>
                  </div>
                  <div className='form-group mb-2'>
                    <label>Permissions</label>
                    <div
                      className='w-100 d-flex justify-content-between flex-wrap overflow-y-auto py-2'
                      style={{height: 120}}
                    >
                      {permissionList.map((permission: any) => (
                        <div className='form-check w-lg-50 w-50 mb-2' key={permission.value}>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            id={permission.value}
                            value={permission.value}
                            checked={formData.permissions.includes(permission.value)}
                            onChange={handlePermissionChange}
                          />
                          <label className='form-check-label' htmlFor={permission.value}>
                            {permission.label}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className='modal-footer'>
                    <button type='submit' className='btn btn-primary' style={{borderRadius: 85}}>
                      Invite User
                    </button>
                    {/* <button className='btn btn-secondary' onClick={() => setShowModal(false)}>
                      Cancel
                    </button> */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete MODAL */}
      {deleteModal && (
        <div className='modal' style={{display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
          <div className='modal-dialog modal-lg modal-dialog-centered'>
            <div className='modal-content container'>
              <div className='modal-header'>
                <h5 className='modal-title'>Remove User</h5>
                <button className='btn btn-close' onClick={() => setDeleteModal(false)}>
                  {/* <span aria-hidden='true'>&times;</span> */}
                </button>
              </div>
              <div className='modal-body users'>
                {/* Form */}
                <h5>
                  Removing this user will delete this profile and will not grant this user access
                  into this organisation anymore.
                </h5>
                <div className='col-12 text-end'>
                  <button
                    type='button'
                    className='btn btn-outline-primary'
                    style={{border: '1px solid #000000', borderRadius: 80}}
                    onClick={() => setDeleteModal(false)}
                  >
                    Keep User
                  </button>
                  <button
                    type='button'
                    className='btn btn-primary mx-2'
                    style={{border: '1px solid #000000', borderRadius: 80}}
                    onClick={deleteUser}
                  >
                    Remove User
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className='col-lg-12' style={{marginTop: 25}} />

      {/* users List */}
      <div className='mb-5'>
        <div className='table-responsive'>
          <div className='d-flex justify-content-between w-100 p-3 pb-2'>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5'>Name</span>
            </td>
            <td className='w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5'>Date Created</span>
            </td>
            {/* <td className='text-start w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5'>Last Active</span>
            </td> */}
            <td className='text-center w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5'></span>
            </td>
          </div>
          {userList.map((e: any, index: number) => (
            <div
              className='p-3 py-2 mb-2 bg-white d-flex justify-content-between w-100'
              key={index}
              style={{marginBottom: 20, borderRadius: 5}}
            >
              <td className='d-flex w-lg-25'>
                <Link
                  to={'/settings/user/details/' + e?.userDetails?.id}
                  className='text-dark fw-bold text-hover-primary fs-6 text-capitalize'
                >
                  <img src='/media/icons/profile.png' alt='profile' height={45} />
                  <div className='px-2'>
                    <a href='#' className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
                      {e?.name}
                    </a>
                    <span className='text-muted fw-semibold d-block'>{e?.email}</span>
                  </div>
                </Link>
              </td>
              <td className='d-flex w-lg-25'>
                <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                  {moment(e?.created_at).format('MMMM Do, YYYY')}
                </span>
              </td>
              {/* <td className='d-flex text-start w-lg-25'>
                <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                  {e?.active_at}
                </span>
              </td> */}
              <td className='d-flex w-lg-25'>
                <div className='d-flex justify-content-end flex-shrink-0 align-items-center'>
                  {/* <select
                    disabled
                    className='form-select mx-2'
                    value={e?.role_id}
                    style={{minWidth: 150, color: '#000'}}
                  >
                    <option value={2}>Company Admin</option>
                    <option value={3}>Administrator</option>
                    <option value={4}>Reviewer</option>
                  </select> */}
                  <button className='btn btn-outlined-dark text-dark' style={{background: '#EAEAEA', width: '155px', marginRight: '30px'}}>{ e?.role_id===2? 'Company Admin' : (e?.role_id===3? 'Administrator' : 'Reviewer') }</button>
                  {
                    (e?.userDetails?.id !== currentUser?.user_id) &&
                      (
                        <button
                          onClick={() => {
                            setDeleteModal(true)
                            setSelectedUser(e)
                          }}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                        >
                          <span className='svg-icon svg-icon-3'>
                            <svg
                              width='24'
                              height='24'
                              viewBox='0 0 24 24'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                              className='mh-50px'
                            >
                              <path
                                d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                                fill='currentColor'
                              ></path>
                              <path
                                opacity='0.5'
                                d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                                fill='currentColor'
                              ></path>
                              <path
                                opacity='0.5'
                                d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                                fill='currentColor'
                              ></path>
                            </svg>
                          </span>
                        </button>
                      )
                  } 
                </div>
              </td>
            </div>
          ))}
          {/* </tbody> */}
        </div>
      </div>

      <div className='col-lg-12' style={{marginTop: 35}} />

      {/* Pending Invites */}
      <h5 style={{color: '#8E8E8E'}}>Pending Invites</h5>
      {pendingUsers?.map((e: any, index: number) => (
        <div
          className='p-3 py-2 mb-2 bg-white d-flex justify-content-between'
          style={{marginBottom: 20, borderRadius: 5}}
          key={index}
        >
          <td className='d-flex'>
            <img src='/media/icons/profile.png' alt='profile' height={45} />
            <div className='px-2'>
              <a href='#' className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
                {e?.name}
              </a>
              <span className='text-muted fw-semibold d-block'>{e?.email}</span>
            </div>
          </td>
          <td className='d-flex'>
            <div className='d-flex justify-content-center flex-shrink-0'>
              <button
                type='button'
                className='btn btn-outlined-dark text-dark'
                style={{background: '#EAEAEA'}}
                onClick={() => resendInvite(e?.id)}
              >
                Resend Invite
              </button>
              <button
                type='button'
                className='btn btn-outlined-danger'
                style={{color: '#FF1616'}}
                onClick={() => revokeInvite(e?.id)}
              >
                Revoke Invite
              </button>
            </div>
          </td>
        </div>
      ))}
      {pendingUsers?.length === 0 && <h5>No pending invites left</h5>}
    </div>
  )
}

export default SettingUsers
